<template>
  <div class="columns-container">
    <div class="column">
      <quote-list-block>
        <template #header>
          <div class="title">
            {{ i18n.t('/Configuration/ConsumerPriceInclBtwBpm') }}
          </div>
        </template>
        <template #body>
          <li class="row">
            <div>
              <div class="price price-incl" data-qa="configuration-incl-price">
                <label>{{ i18n.t('/totalen/totaal') }}</label>
                <span>{{ i18n.n(OriginalNetCatalogPrice, 'currency') }}</span>
              </div>
            </div>
          </li>
        </template>
      </quote-list-block>
    </div>
    <div class="column">
      <quote-list-block>
        <template #header>
          <div class="title">
            {{ i18n.t('/Configuration/ConsumerPriceInclBtwBpm') }}
          </div>
        </template>
        <template #body>
          <li class="row">
            <div>
              <div class="price price-incl" data-qa="configuration-incl-price">
                <label>{{ i18n.t('/totalen/totaal') }}</label>
                <span>{{ i18n.n(ChangedNetCatalogPrice, 'currency') }}</span>
              </div>
            </div>
          </li>
          <li class="row">
            <div>
              <div v-if="showDetails" class="price-details">
                <div>
                  <label>{{ i18n.t('/change-order/price-details/diff-excl-bpm-excl-btw') }}</label>
                  <span>{{ getPriceDiffNett }}</span>
                </div>
                <div>
                  <label>{{ i18n.t('/change-order/price-details/diff-btw') }}</label>
                  <span>{{ getPriceDiffVat }}</span>
                </div>
                <div>
                  <label>{{ i18n.t('/change-order/price-details/diff-bpm') }}</label>
                  <span>{{ getPriceDiffBPM }}</span>
                </div>
              </div>

              <div :class="getPriceDifferenceClass" @click="toggleDetails">
                <label>{{ i18n.t('/change-order/price-details/diff-total') }}</label>
                <span>{{ getPriceDifferenceTotal }}</span>
                <i :class="`fas ${showDetails ? 'fa-chevron-up' : 'fa-chevron-down'}`"></i>
              </div>
            </div>
          </li>
        </template>
      </quote-list-block>
    </div>
  </div>
</template>

<script>
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import { mapGetters } from 'vuex'

export default {
  components: { QuoteListBlock },
  data() {
    return {
      showDetails: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      changeOrder: 'changeOrder/get',
    }),
    OriginalNetCatalogPrice() {
      return this.changeOrder?.CarConfiguration?.OriginalNetCatalogPrice?.Incl
    },
    ChangedNetCatalogPrice() {
      return this.changeOrder?.CarConfiguration?.ChangedNetCatalogPrice?.Incl
    },
    getPriceDiffBPM() {
      let originalBpm = this.changeOrder.CarConfiguration.OriginalNetCatalogPrice.Bpm
      let changedBpm = this.changeOrder.CarConfiguration.ChangedNetCatalogPrice.Bpm
      let bpmPriceDifference = changedBpm - originalBpm
      return this.getPriceDiffSign(bpmPriceDifference)
    },
    getPriceDiffNett() {
      let originalExcl = this.changeOrder.CarConfiguration.OriginalNetCatalogPrice.Excl
      let changedExcl = this.changeOrder.CarConfiguration.ChangedNetCatalogPrice.Excl
      let exclPriceDifference = changedExcl - originalExcl
      return this.getPriceDiffSign(exclPriceDifference)
    },
    getPriceDiffVat() {
      let originalVAT = this.changeOrder.CarConfiguration.OriginalNetCatalogPrice.Btw
      let changedVAT = this.changeOrder.CarConfiguration.ChangedNetCatalogPrice.Btw
      let vatPriceDifference = changedVAT - originalVAT
      return this.getPriceDiffSign(vatPriceDifference)
    },
    getPriceDifferenceTotal() {
      let originalNetCatalogPrice =
        this.changeOrder?.CarConfiguration?.OriginalNetCatalogPrice?.Incl
      let changedNetCatalogPrice = this.changeOrder?.CarConfiguration?.ChangedNetCatalogPrice?.Incl

      let priceTotal = changedNetCatalogPrice - originalNetCatalogPrice
      return this.getPriceDiffSign(priceTotal)
    },
    getPriceDifferenceClass() {
      let originalNetCatalogPrice =
        this.changeOrder?.CarConfiguration?.OriginalNetCatalogPrice?.Incl
      let changedNetCatalogPrice = this.changeOrder?.CarConfiguration?.ChangedNetCatalogPrice?.Incl
      let priceTotal = changedNetCatalogPrice - originalNetCatalogPrice
      if (priceTotal === 0) {
        return 'price-details'
      }
      return 'price-details has-price-difference'
    },
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails
    },
    getPriceDiffSign(price) {
      let absPrice = Math.abs(price)
      if (price < 0) {
        return '- ' + this.i18n.n(absPrice, 'currency')
      }
      if (price === 0) {
        return this.i18n.n(absPrice, 'currency')
      }
      return '+ ' + this.i18n.n(absPrice, 'currency')
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.row) {
  grid-template-columns: auto 1em 2em;
  grid-template-areas: 'title info-icon edit-dialog';
}

.columns-container {
  display: flex;
  justify-content: space-between;
}

.price {
  text-align: right;
  font-weight: 700;
  label {
    padding-right: 10px;
  }
}

.price-details {
  text-align: right;
  font-size: 18px;

  padding-top: 10px;
  padding-bottom: 10px;

  label {
    padding-right: 10px;
  }
  span {
    font-family: Calibri, sans-serif;
  }
}

.price-difference {
  text-align: right;
  font-weight: 700;
  label {
    padding-right: 10px;
  }

  span {
    font-family: Calibri, sans-serif;
  }
}

.has-price-difference {
  label {
    background-color: #fff8b9;
  }
  span {
    background-color: #fff8b9;
  }
}

.fa-chevron-up,
.fa-chevron-down {
  cursor: pointer;
  margin-right: -28px;
  margin-left: 5px;
}

.column {
  flex: 1;
  margin: 0 10px;
}
</style>
